import { type ChallengeSummary } from '@/lib/types';
import { createContext } from 'react';

const ChallengeSummaryContext = createContext<ChallengeSummary>(
  null as unknown as ChallengeSummary,
);

export default ChallengeSummaryContext;
